
import { useState } from "react"
import { NumericFormat } from "react-number-format"
import styled from "styled-components"
import { updateYukData } from "../../../../../features/updateLoad/updateLoadSlice"
import { useDispatch } from "react-redux"
import { useEffect } from "react"

const Container = styled.div`
    width: 200px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const ToplamHacimInput = ({data, name, labelText="Yükün Toplam Hacmi(m3)", isRequired=false}) => {

    const [text, setText] = useState(data.toplamHacim)  
    const dispatch = useDispatch()

    useEffect(() => {
        setText(data.toplamHacim)
    },[data.toplamHacim])


    const handleChange = (e) => {
        setText(e.target.value)
        dispatch(updateYukData({toplamHacim: e.target.value.replace(/[^0-9]/g, '').slice(0, -1)}))
    }

    
  return (
    <Container value={text} radius={"5px"}>
        <NumericFormat type="text" id={"text"} thousandSeparator={'.'} decimalSeparator={','} suffix={` m3`}  onChange={(e) => handleChange(e)} value={text} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default ToplamHacimInput